import { scrollingElement } from '@earthpeople/scroll-spy/es5'

export default function mobileMenuToggle () {
  const elBody = document.querySelector('body')
  const elMainMenu = document.querySelector('.MainMenu')
  const elFooter = document.querySelector('.Footer')
  const elCourseMenu = document.querySelector('.CourseMenu .SiteMenu')
  const elMobileMenuToggle = document.querySelector('.MobileMenuToggle-link')
  const elSidebar = document.querySelector('.CourseSidebar')
  const elSidebarToggle = document.querySelector('.CourseSidebarToggle')

  let scrollPosition = 0
  const showSidebar = () => {
    scrollPosition = scrollingElement.scrollTop
    elBody.classList.add('sidebar-open')
    elBody.style.top = `-${scrollPosition}px`
    elSidebar.classList.add('CourseSidebar--open')
    elSidebarToggle.classList.add('CourseSidebarToggle--show')
  }

  const hideSidebar = () => {
    elBody.classList.remove('sidebar-open')
    window.scrollTo(0, scrollPosition)
    elBody.style.top = `auto`
    elSidebar.classList.remove('CourseSidebar--open')
    elSidebarToggle.classList.remove('CourseSidebarToggle--show')
  }

  elMobileMenuToggle.addEventListener('click', (evt) => {
    evt.preventDefault()

    if (elBody.classList.contains('menu-open')) {
      elBody.classList.remove('menu-open')
      elMainMenu.querySelector('.Footer').remove()
      elMainMenu.querySelector('.SiteMenu--course').remove()
    } else {
      elBody.classList.add('menu-open')
      if (elCourseMenu) {
        const clonedCourseMenu = elCourseMenu.cloneNode(true)
        clonedCourseMenu.classList.add('CourseMenu--open')
        elMainMenu.prepend(clonedCourseMenu)
      }
      const clonedFooter = elFooter.cloneNode(true)
      clonedFooter.classList.add('Footer--open')
      elMainMenu.appendChild(clonedFooter)

    }
  })

  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) {
      if (elBody.classList.contains('menu-open')) {
        elBody.classList.remove('menu-open')
        elMainMenu.querySelector('.Footer').remove()
      }
    }
    if (window.innerWidth > 1199) {
      if (elBody.classList.contains('sidebar-open')) {
        hideSidebar()
      }
    }
  })

  if (elSidebarToggle) {
    elSidebarToggle.addEventListener('click', (evt) => {
      evt.preventDefault()
      if (elBody.classList.contains('sidebar-open')) {
        hideSidebar()
      } else {
        showSidebar()
      }
    })
    elSidebar.addEventListener('click', evt => {
      if (evt.target.classList && evt.target.classList.contains('IndentList-link')) {
        hideSidebar()
      }
    })
  }

}
